import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

const AdminLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showTraditionalLogin, setShowTraditionalLogin] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  
  const { login, googleLogin } = useAdminAuth();

// Cargar script de Google Identity Services
useEffect(() => {
  const handleGoogleResponse = async (response) => {
    setGoogleLoading(true);
    setError('');

    try {
      if (!response.credential) {
        throw new Error('No se recibió credencial de Google');
      }

      const result = await googleLogin(response.credential);
      
      if (result.success) {
        if (onLoginSuccess) {
          onLoginSuccess();
        }
      } else {
        setError(result.error || 'Error al autenticar con Google');
      }
    } catch (error) {
      console.error('Error en Google login:', error);
      setError('Error al procesar la autenticación con Google');
    } finally {
      setGoogleLoading(false);
    }
  };

  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  script.onload = () => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '123456789-abcdef.apps.googleusercontent.com',
        callback: handleGoogleResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
      });

      // Renderizar el botón de Google
      setTimeout(() => {
        const googleButtonElement = document.getElementById('google-signin-button');
        if (googleButtonElement && window.google) {
          window.google.accounts.id.renderButton(
            googleButtonElement,
            {
              theme: 'filled_blue',
              size: 'large',
              type: 'standard',
              text: 'continue_with',
              shape: 'rectangular',
              logo_alignment: 'left',
              width: '100%'
            }
          );
        }
      }, 100);
    }
  };

  return () => {
    document.body.removeChild(script);
  };
}, [googleLogin, onLoginSuccess]);  // Agregar dependencias

  const handleTraditionalSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    
    if (result.success) {
      if (onLoginSuccess) {
        onLoginSuccess();
      }
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '30px'
        }}>
          <h2 style={{
            color: '#4a5568',
            margin: '0 0 8px 0',
            fontSize: '1.8em',
            fontWeight: '600'
          }}>
            Iniciar Sesión Admin
          </h2>
          <p style={{
            color: '#718096',
            margin: '0',
            fontSize: '1em'
          }}>
            Panel de gestión de eventos
          </p>
        </div>

        {error && (
          <div style={{
            background: '#fed7d7',
            border: '1px solid #feb2b2',
            color: '#c53030',
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '0.9em',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {!showTraditionalLogin ? (
          // Vista principal con Google OAuth
          <div>
            {/* Botón de Google */}
            <div style={{
              marginBottom: '20px',
              position: 'relative'
            }}>
              <div 
                id="google-signin-button"
                style={{
                  display: googleLoading ? 'none' : 'block',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              ></div>
              
              {googleLoading && (
                <div style={{
                  width: '100%',
                  padding: '12px',
                  background: '#4285f4',
                  color: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}>
                  <span style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></span>
                  Verificando con Google...
                </div>
              )}
            </div>

            {/* Separador */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              margin: '25px 0',
              color: '#a0aec0',
              fontSize: '0.9em'
            }}>
              <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }}></div>
              <span style={{ padding: '0 15px' }}>o</span>
              <div style={{ flex: 1, height: '1px', background: '#e2e8f0' }}></div>
            </div>

            {/* Botón para mostrar login tradicional */}
            <button
              onClick={() => setShowTraditionalLogin(true)}
              style={{
                width: '100%',
                background: 'transparent',
                color: '#667eea',
                border: '2px solid #667eea',
                padding: '12px 20px',
                borderRadius: '8px',
                fontSize: '1em',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#667eea';
                e.target.style.color = 'white';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#667eea';
              }}
            >
              Usar email y contraseña
            </button>
          </div>
        ) : (
          // Vista de login tradicional
          <div>
            {/* Botón para volver */}
            <button
              onClick={() => {
                setShowTraditionalLogin(false);
                setError('');
                setEmail('');
                setPassword('');
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#667eea',
                fontSize: '0.9em',
                cursor: 'pointer',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              ← Volver a opciones de login
            </button>

            <form onSubmit={handleTraditionalSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '600',
                  color: '#4a5568',
                  fontSize: '0.95em'
                }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@pedidosdeoraccion.com"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '10px',
                    fontSize: '1em',
                    transition: 'all 0.3s ease',
                    fontFamily: 'inherit',
                    backgroundColor: loading ? '#f7fafc' : 'white',
                    cursor: loading ? 'not-allowed' : 'text'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '600',
                  color: '#4a5568',
                  fontSize: '0.95em'
                }}>
                  Contraseña
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '10px',
                    fontSize: '1em',
                    transition: 'all 0.3s ease',
                    fontFamily: 'inherit',
                    backgroundColor: loading ? '#f7fafc' : 'white',
                    cursor: loading ? 'not-allowed' : 'text'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <button 
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  background: loading ? 'rgba(102, 126, 234, 0.7)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '15px 20px',
                  borderRadius: '10px',
                  fontSize: '1.1em',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.target.style.transform = 'none';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              >
                {loading ? (
                  <>
                    <span style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></span>
                    Verificando...
                  </>
                ) : (
                  'Iniciar Sesión'
                )}
              </button>
            </form>
          </div>
        )}

        <div style={{
          textAlign: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #e2e8f0',
          marginTop: '20px'
        }}>
          <p style={{
            color: '#a0aec0',
            fontSize: '0.85em',
            margin: '0'
          }}>
            Sistema administrativo de Pedidos de Oración
          </p>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @media (max-width: 480px) {
            .admin-login-container {
              padding: 15px;
            }
            .admin-login-card {
              padding: 30px 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AdminLogin;